<app-personalized-dialog [loading]="loading">
    <div dialog-title>
        Reset Password - {{ user?.name }}
    </div>

    <div dialog-content>
        <form [formGroup]="formResetPassword" autocomplete="off" ngNativeValidate (ngSubmit)="resetPassword()"
            id="resetPasswordForm">
            <div class="kite-section-card mb-0">
                <div class="kite-section-title">
                    <span>Password Security</span>
                </div>

                <div class="alert alert-info py-2 px-3 mb-3 text-xs flex items-center gap-2" role="alert">
                    <i class="fa fa-info-circle shrink-0"></i>
                    <span>You are about to reset the password for <strong>{{ user?.email }}</strong></span>
                </div>

                <div class="row g-2">
                    <div class="col-md-6">
                        <app-custom-input type="password" label="New Password" placeholder="Enter new password"
                            [control]="formResetPassword?.get('password')" id="resetPassword" [showPasswordToggle]="true">
                        </app-custom-input>
                        <small class="text-muted">Minimum 6 characters</small>
                    </div>

                    <div class="col-md-6">
                        <app-custom-input type="password" label="Confirm Password" placeholder="Confirm new password"
                            [control]="formResetPassword?.get('confirmPassword')" id="resetConfirmPassword"
                            [showPasswordToggle]="true">
                        </app-custom-input>
                        <small class="text-danger"
                            *ngIf="formResetPassword?.get('confirmPassword')?.hasError('passwordMismatch') && formResetPassword?.get('confirmPassword')?.touched">
                            Passwords do not match
                        </small>
                    </div>
                </div>
            </div>
        </form>
    </div>

    <div dialog-actions>
        <div class="d-flex justify-content-end gap-2 w-100">
            <app-button type="button" variant="secondary" (onClick)="closeModal()">
                Cancel
            </app-button>
            <app-button type="submit" form="resetPasswordForm" [disabled]="loading || !formResetPassword.valid"
                variant="primary">
                {{ loading ? 'Resetting...' : 'Reset Password' }}
            </app-button>
        </div>
    </div>
</app-personalized-dialog>